import { extent, max, scaleLinear, select } from 'd3';
import { ChartDimensions, IBarPoint, IBarPoints } from '../interfaces/barGraph';


export class Graph {
  svgRef;

  constructor(
    private containerRef: HTMLElement,
    private svgWidth: number,
    private svgHeight: number,
    private barWidth: number,
    private data: IBarPoints,
    private customValueRange: number[],
    private customChartDimensions: ChartDimensions,
  ) { }

  private getYAxisDomainExtent(data): number[] {
    return [0, max(data, (d: any) => parseInt(d.value, 10))];
  }

  drawSvgContainer() {
    this.svgRef = select(this.containerRef).append('svg')
      .attr('width', this.svgWidth)
      .attr('height', this.svgHeight)
      .attr('fill', 'none')
      .attr('class', 'svg-container')
      .append('g');

    return this.svgRef;
  }

  updateData(
    svgWidth: number,
    svgHeight: number,
    data: IBarPoints,
    customValueRange: number[],
    customChartDimensions: ChartDimensions,
  ) {
    this.svgWidth = svgWidth;
    this.svgHeight = svgHeight;
    this.data = data;
    this.customValueRange = customValueRange;
    this.customChartDimensions = customChartDimensions;
    this.svgRef
      .attr('width', this.svgWidth)
      .attr('height', this.svgHeight);
  }

  getYRange() {
    let yRange: number[];
    if (!this.customValueRange) {
      yRange = this.getYAxisDomainExtent(this.data);
    } else {
      yRange = this.customValueRange;
    }

    return yRange;
  }

  getChartDimensions() {
    if (!this.customChartDimensions) {
      return {
        chartWidth: this.svgWidth,
        chartHeight: this.svgHeight
      };
    }

    return this.customChartDimensions;
  }

  private getXAxisDomain(data: IBarPoints) {
    return extent(data, (d: IBarPoint) => d.name);
  }

  getGraphScale(tickCount?: number) {
    const { chartWidth, chartHeight } = this.getChartDimensions();
    const yRange = this.getYRange();
    const ext = <number[]> this.getXAxisDomain(this.data);

    const xScale = scaleLinear().domain(ext).range([ 0, chartWidth - this.barWidth ]);
    const yScale = scaleLinear().domain([ yRange[0], yRange[1] ]).range([ chartHeight, 0 ]);

    if (tickCount) {
      yScale.nice(tickCount);
    }

    return { xScale, yScale };
  }
}
